// Imports => Constants
import { ENDPOINTS } from '@constants';

export class PublicationsAPI {
  constructor(Instance) {
    this.Store = Instance.Store;
    this.Client = Instance.Client;
  }

  search(params) {
    return this.Client.get(ENDPOINTS.PUBLICATIONS.SEARCH, { params })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  // Haalt ALLE bijlagen op, niet alleen de eerste (default 30). Het
  // attachments-endpoint is gepagineerd (results + total/pages/limit); zonder
  // door te pagineren zou een publicatie met veel bijlagen (bv. 178) er maar 30
  // tonen. We vragen een grote pagina op en halen eventuele resterende pagina's
  // erbij, zodat de client-side pager over de volledige set kan bladeren.
  async attachments(id) {
    const PER_PAGE = 500; // OAS-max per pagina
    const first = await this.Client.get(ENDPOINTS.PUBLICATIONS.ATTACHMENTS(id), {
      params: { _limit: PER_PAGE },
    }).then((response) => response.data);

    const results = Array.isArray(first?.results) ? [...first.results] : [];
    const pages = first?.pages || 1;

    if (pages > 1) {
      const rest = await Promise.all(
        Array.from({ length: pages - 1 }, (_, index) =>
          this.Client.get(ENDPOINTS.PUBLICATIONS.ATTACHMENTS(id), {
            params: { _limit: PER_PAGE, _page: index + 2 },
          }).then((response) => response.data)
        )
      );
      rest.forEach((response) => {
        if (Array.isArray(response?.results)) {
          results.push(...response.results);
        }
      });
    }

    return { ...first, results, total: first?.total ?? results.length };
  }

  single(id, params) {
    return this.Client.get(ENDPOINTS.PUBLICATIONS.SINGLE(id, params)).then((response) => response.data);
  }

  themes(params) {
    return this.Client.get(ENDPOINTS.THEMES, { params }).then((response) => response.data);
  }

  // Facets liften mee op de gewone lijstcall via _facetable/_facets-params;
  // de aparte aggregations-Accept-header bestaat niet meer in de nieuwe API.
  searchAggregations(params) {
    return this.Client.get(ENDPOINTS.PUBLICATIONS.SEARCH, { params }).then(
      (response) => response.data
    );
  }
}

export default PublicationsAPI;
